import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentSpecialFreightTrackingState } from './shipment-special-freight-tracking.state';
import { Observable } from 'rxjs';
import {
  ShipmentSpecialFreightTrackingSetInitialState,
  ShipmentSpecialFreightTrackingLoad,
} from './shipment-special-freight-tracking.actions';
import { SpecialFreightMilestoneModel } from '../../models';
import { LinkInfoType, SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightTrackingFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentSpecialFreightTrackingState.getLoaded);
  milestones$: Observable<SpecialFreightMilestoneModel[]> = this.store.select(
    ShipmentSpecialFreightTrackingState.getMilestones,
  );
  transportMode$: Observable<LinkInfoType> = this.store.select(ShipmentSpecialFreightTrackingState.getTransportMode);
  constructor(private store: Store) {}

  loadAll(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightTrackingLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentSpecialFreightTrackingSetInitialState());
  }
}
